import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';

const ToastContext = React.createContext(null);

export const useToastContext = () => useContext(ToastContext);

export function useToasts() {
    const { toasts = null } = useToastContext() || {};
    return toasts || null;
}

export function useAddToast() {
    const { addToast = null } = useToastContext() || {};
    return addToast || null;
}

export function useRemoveToast() {
    const { removeToast = null } = useToastContext() || {};
    return removeToast || null;
}

const propTypes = {
    children: PropTypes.node.isRequired,
    toasts: PropTypes.arrayOf(PropTypes.shape({})),
};

export const ToastProvider = ({ children = null, toasts: initialToasts = [] }) => {
    const [toasts, setToasts] = useState(initialToasts);

    const addToast = useCallback(
        (toast) => {
            setToasts([...toasts, toast]);
        },
        [toasts, setToasts],
    );

    const removeToast = useCallback(
        (id) => {
            setToasts(toasts.filter((toast) => toast.id !== id));
        },
        [toasts, setToasts],
    );

    useEffect(() => {
        const timer = setTimeout(() => {
            if (toasts.length > 0) {
                setToasts(toasts.slice(1));
            }
        }, 8000);
        return () => clearInterval(timer);
    }, [toasts, setToasts]);

    const value = useMemo(
        () => ({
            addToast,
            removeToast,
            toasts,
        }),
        [addToast, removeToast, toasts],
    );
    return <ToastContext.Provider value={value}>{children}</ToastContext.Provider>;
};

ToastProvider.propTypes = propTypes;

export default ToastContext;
